import React, { useEffect, useState } from "react";
import { Sectors, Companies, Period, Tags } from "./_index";
import { getCategories } from "../../frameworks/mz-wp-api";

export default function Filters({
    showSectors = true,
    showCompanies = true,
    showPeriod = true,
    showTags = true,
    haveCalendar = false,
    startOpen = false,
    setCategoriesList,
}) {
    const [categoriesList, updateCategoriesList] = useState([]);

    const [sectors, setSectors] = useState([]);
    const [tags, setTags] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [years, setYears] = useState([]);
    const [quarters, setQuarters] = useState([]);

    const [selectedSector, setSelectedSector] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState([]);
    const [selectedYear, setSelectedYear] = useState([]);
    const [selectedQuarter, setSelectedQuarter] = useState([]);
    const [selectedTag, setSelectedTag] = useState([]);

    const [selectedCategories, setSelectedCategories] = useState([]);

    const [open, setOpen] = useState(startOpen);
    const [applyClicked, setApplyClicked] = useState(false);

    // inputs
    const [sectorsIptValue, setSectorsIptValue] = useState("");
    const [companiesIptValue, setCompaniesIptValue] = useState("");
    const [uncheck, setUncheck] = useState(false);
    // const [disableFilters, setDisableFilters] = useState(true);

    useEffect(() => {
        getCategories((postTerms) => {
            // console.log("disableFilters", disableFilters);
            // if (disableFilters) return;

            let allChildren = [];
            let categories = {};

            Object.values(postTerms.categories).forEach((category) => {
                const children = Object.values(category.children);
                if (children.length > 0) {
                    categories[category.slug] = children;
                    allChildren.push(...children);
                }
            });

            allChildren.push(...postTerms.tags);

            if (showSectors) setSectors(categories[sectorsParent.slug] || []);

            if (showTags) setTags(postTerms.tags || []);

            if (showCompanies) setCompanies(categories[companiesParent.slug] || []);

            if (showPeriod) setYears(categories[yearsParent.slug] || []);

            if (showPeriod) setQuarters(categories[quartersParent.slug] || []);

            updateCategoriesList(allChildren);

            setFilters();
        });
    }, []);

    useEffect(() => {
        let newSelectedCategories = [...selectedSector, ...selectedTag, ...selectedCompany, ...selectedYear, ...selectedQuarter];
        setSelectedCategories([...newSelectedCategories]);
    }, [selectedSector, selectedTag, selectedCompany, selectedYear, selectedQuarter]);

    /**
     * @param {String} category The category slug.
     * @param {Boolean} checked Set the checkbox `checked`?
     */
    function toggleCheckbox(category, checked) {
        category.setChecked(checked);
        category.setSelected([]);
        setFilters();
    }

    function setFilters() {
        const noCategoriesSelected = !(
            selectedSector.length == 0 &&
            selectedCompany.length == 0 &&
            selectedYear.id &&
            selectedQuarter.length == 0 &&
            selectedTag.length == 0
        );

        let newTerms = {
            sectorsCategories: noCategoriesSelected && !open ? undefined : selectedSector,
            companiesCategories: noCategoriesSelected && !open ? undefined : selectedCompany,
            yearsCategories: noCategoriesSelected && !open ? undefined : selectedYear,
            quartersCategories: noCategoriesSelected && !open ? undefined : selectedQuarter,
            tag: noCategoriesSelected && !open ? undefined : selectedTag,
            filtered: noCategoriesSelected && !open ? false : true,
        };

        setCategoriesList(newTerms);
    }

    function getCategoryBy(id) {
        for (let category of categoriesList) {
            if (category.term_id === id) {
                return category;
            }
        }
    }

    const handleApplyButton = function (e) {
        e.preventDefault();

        setApplyClicked(true);

        setUncheck(false);

        let newSelectedCategories = [...selectedSector, ...selectedTag, ...selectedCompany, ...selectedYear, ...selectedQuarter];
        setSelectedCategories([...newSelectedCategories]);

        setFilters();

        setOpen(false);
    };

    const handleClearButton = function (e) {
        e.preventDefault();

        if (applyClicked) {
            setApplyClicked(false);

            setSectorsIptValue("");
            setCompaniesIptValue("");

            setSelectedSector([]);
            setSelectedTag([]);
            setSelectedCompany([]);
            setSelectedYear([]);
            setSelectedQuarter([]);
            setSelectedCategories([]);

            if (document.querySelector("#yearFilter")) {
                console.log("year cleaned");
                document.querySelector("#yearFilter").value = "";
            }

            setUncheck(true);

            setFilters();
        }
    };

    const handleGalleryBtn = function () {
        document.body.classList.add("galleryView");
        document.body.classList.remove("listView");
    };

    const handleListBtn = function () {
        document.body.classList.remove("galleryView");
        document.body.classList.add("listView");
    };

    const handleDatepickerBtn = function (event) {
        const datepicker = document.getElementById("datepicker")?.parentElement;
        datepicker.hidden = !datepicker.hidden;
        event.target.ariaExpanded = datepicker.hidden ? "false" : "true";
    };

    return (
        <>
            <div className="container">
                <div className="topBar">
                    <button className="toggleFilters" open={open && "open"} onClick={() => setOpen(!open)}>
                        {filtersTxt}
                    </button>
                    <nav className="viewMode">
                        {haveCalendar && (
                            <button id="toggleDatepicker" aria-expanded="false" aria-controls="datepicker" onClick={handleDatepickerBtn}>
                                {calendarTxt}
                            </button>
                        )}
                        <button className="viewButton gallery" id="setGalleryMode" onClick={handleGalleryBtn}></button>
                        <button className="viewButton list" id="setListMode" onClick={handleListBtn}></button>
                    </nav>
                </div>

                <form className="filters" open={open ? "open" : undefined}>
                    <div className="row no-gutters align-items-start">
                        {showSectors ? (
                            <Sectors
                                sectors={sectors}
                                selectedSector={selectedSector}
                                setSelectedSector={setSelectedSector}
                                sectorsIptValue={sectorsIptValue}
                                setSectorsIptValue={setSectorsIptValue}
                            />
                        ) : (
                            ""
                        )}
                        {showCompanies ? (
                            <Companies
                                companies={companies}
                                selectedCompany={selectedCompany}
                                setSelectedCompany={setSelectedCompany}
                                companiesIptValue={companiesIptValue}
                                setCompaniesIptValue={setCompaniesIptValue}
                            />
                        ) : (
                            ""
                        )}
                        {showPeriod ? (
                            <Period
                                years={years}
                                quarters={quarters}
                                selectedYear={selectedYear}
                                selectedQuarter={selectedQuarter}
                                setSelectedYear={setSelectedYear}
                                setSelectedQuarter={setSelectedQuarter}
                                uncheck={uncheck}
                            />
                        ) : (
                            ""
                        )}
                        {showTags ? <Tags tags={tags} selectedTag={selectedTag} setSelectedTag={setSelectedTag} /> : ""}
                    </div>
                </form>
            </div>
            <div className="filterTags" open={selectedCategories.length > 0}>
                <div className="container">
                    <div className="tags">
                        {selectedCategories.map((category) => {
                            const tag = getCategoryBy(category);
                            return (
                                <button key={`tag_${category.id}`} className="tag" onClick={() => toggleCheckbox(category, false)}>
                                    {tag.name}
                                </button>
                            );
                        })}
                    </div>
                    <button className="btn submitFilter" onClick={handleApplyButton}>
                        {applyFiltersTxt}
                    </button>
                    <button className="clearTags" onClick={handleClearButton} disabled={applyClicked ? false : true}>
                        {clearFiltersTxt}
                    </button>
                </div>
            </div>
        </>
    );
}
